import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AppConstants } from 'src/app-constants';
import { RoleTypeSM } from '../service-models/enums/role-type-s-m.enum';
import { LoginUserSM } from '../service-models/v1/app-users/login/login-user-s-m';
import { StorageService } from '../services/storage.service';
import decode from 'jwt-decode';
import { AccountService } from '../services/account.service';
const jwtHelper = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(
    private storageService: StorageService,
    private accountService: AccountService,
    public router: Router) {

  }
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    if (!await this.IsTokenValid()) {
      await this.router.navigate([AppConstants.WebRoutes.Home]);
      await this.accountService.logoutUser();
      return false;
    }
    const expectedRole = route.data['allowedRole'];
    if (!await this.IsRoleForRoute(expectedRole)) {
      this.router.navigate([AppConstants.WebRoutes.UNAUTHORIZED]);
      return false;
    }
    return true;
  }

  async canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    const token: string = await this.storageService.getFromStorage(AppConstants.DbKeys.ACCESS_TOKEN);
    return !jwtHelper.isTokenExpired(token);
  }

  async IsTokenValid(): Promise<boolean> {
    const token: string = await this.storageService.getTokenFromStorage();
    return token != null && token != "" && !jwtHelper.isTokenExpired(token);
  }

  async IsRoleForRoute(expectedRole: any): Promise<boolean> {
    const token: string = await this.storageService.getTokenFromStorage();
    const tokenPayload: any = decode(token);
    let tokenRole = RoleTypeSM[tokenPayload[AppConstants.Token_Info_Keys.Role]];
    if (tokenRole === expectedRole)
      return true;
    return false;
  }

}
